import { useCountrySettings } from 'state/slices/api/api.hooks'

export const useShowPerformanceData = (coworkerId: string) => {
  const { data: settings, isLoading } = useCountrySettings(coworkerId)

  return { show: settings?.enablePerformanceData ?? false, isLoading }
}
